import { render, staticRenderFns } from "./VeCornersPicker.vue?vue&type=template&id=4e4754d4&scoped=true"
import script from "./VeCornersPicker.vue?vue&type=script&lang=js"
export * from "./VeCornersPicker.vue?vue&type=script&lang=js"
import style0 from "./VeCornersPicker.vue?vue&type=style&index=0&id=4e4754d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4754d4",
  null
  
)

export default component.exports